export default __webpack_public_path__ + "static/media/43_mobile.f53f31ab.jpg";